// extracted by mini-css-extract-plugin
export var dash = "F_cs";
export var path = "F_cr";